
import { defineComponent } from 'vue';
import { mapState, mapActions } from 'vuex';
import HeaderNav from './HeaderNav.vue';
import SelectArrowIcon from '@/components/icons/SelectArrowIcon.vue';
import AvatarIcon from '@/components/icons/AvatarIcon.vue';
import LogoutIcon from '@/components/icons/LogoutIcon.vue';
import { logout } from '@/api/apis';
import FacebookIcon from '@/components/icons/FacebookIcon.vue';
import LinkedInIcon from '@/components/icons/LinkedInIcon.vue';

export default defineComponent({
  name: 'Header',
  components: {
    HeaderNav,
    SelectArrowIcon,
    AvatarIcon,
    LogoutIcon,
    FacebookIcon,
    LinkedInIcon
  },
  computed: {
    ...mapState(['lang', 'langs', 'userInfo'])
  },
  methods: {
    ...mapActions(['setLang', 'changeAndSetLangMessage', 'clearLoginInfo']),
    handleLangChange(value: string) {
      this.setLang(value);
      this.changeAndSetLangMessage(value);
    },
    async handleLogout() {
      await logout();
      await this.clearLoginInfo();

      this.$router.replace('/home');
    },
    handleLogoClick() {
      if (!this.userInfo) {
        this.$router.push('/home');
      } else {
        this.$router.push('/vehicle');
      }
    }
  }
});
